import { type VariantProps, cva } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '../utils'

const badgeVariants = cva(
  'inline-flex font-semibold items-center rounded-md border px-1 py-0.25 transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'rounded-sm border-dark ',
        secondary:
          'border-transparent bg-secondary text-foreground/80 hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive/10 font-semibold text-destructive',
        outline: 'text-foreground',
        success: 'bg-green/10 text-green font-semibold border-0',
        warn: 'bg-warn/10 text-warn border-0',
      },
      size: {
        md: 'text-md py-1 px-2',
        sm: 'text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'sm',
    },
  },
)

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <span
        className={cn(badgeVariants({ variant, size }), className)}
        {...props}
        ref={ref}
      />
    )
  },
)

export { Badge, badgeVariants }
